import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';

export default {
  install(Vue, options) {
    Vue.prototype.getPdfByPage = async function(id, direction, compress) {
      try {
        const title = this.htmlTitle;
        const element = document.querySelector('#' + id);
        if (!element) {
          console.error(`Element with id ${id} not found`);
          return;
        }
        
        // 获取元素原始尺寸
        const originalWidth = element.offsetWidth;
        const originalHeight = element.scrollHeight;
        
        // 定义固定宽高比 (1:1.414)
        const fixedAspectRatio = 1 / Math.sqrt(2);
        
        // 计算每页内容高度（基于固定宽高比）
        const pageContentHeight = Math.floor(originalWidth / fixedAspectRatio);

        // 计算总页数（基于原始内容高度）
        const pageCount = Math.ceil(originalHeight / pageContentHeight);
        
        // 设置方向
        if (!direction) {
          direction = 'p'; // L/P
        }
        
        // 创建PDF实例
        const PDF = new JsPDF(direction, 'pt', 'a4');
        const pageWidth = PDF.internal.pageSize.getWidth();
        const pageHeight = PDF.internal.pageSize.getHeight();
        
        // 设置页边距（单位：pt）
        const margin = 20;
        
        // 计算PDF内容区域尺寸（保持固定比例）
        const pdfContentWidth = pageWidth - 2 * margin;
        const pdfContentHeight = pdfContentWidth / fixedAspectRatio;
        
        for (let page = 0; page < pageCount; page++) {
          // 创建临时容器
          const tempContainer = document.createElement('div');
          tempContainer.style.position = 'absolute';
          tempContainer.style.left = '-9999px';
          tempContainer.style.width = `${originalWidth}px`;
          tempContainer.style.height = `${pageContentHeight}px`;
          tempContainer.style.backgroundColor = 'white';
          tempContainer.style.boxSizing = 'border-box';
          tempContainer.style.overflow = 'hidden';
          
          // 克隆原始元素
          const contentClone = element.cloneNode(true);
          contentClone.style.position = 'relative';
          contentClone.style.top = `-${page * pageContentHeight}px`;
          contentClone.style.width = '100%';
          contentClone.style.margin = '0';
          contentClone.style.padding = '0';
          contentClone.style.boxSizing = 'border-box';
          
          tempContainer.appendChild(contentClone);
          document.body.appendChild(tempContainer);
          
          // 渲染当前页
          const canvas = await html2canvas(tempContainer, {
            allowTaint: true,
            dpi: compress ? 150 : 300,
            scale: compress ? 2 : 4,
            useCORS: true,
            logging: false,
            backgroundColor: '#FFFFFF',
            width: originalWidth,
            height: pageContentHeight
          });
          
          // 清理临时容器
          document.body.removeChild(tempContainer);
          
          // 计算在PDF中的位置（垂直居中）
          const yPos = margin + (pageHeight - 2 * margin - pdfContentHeight) / 2;
          
          // 添加到PDF
          if (page > 0) PDF.addPage();
          PDF.addImage(
            canvas, 
            'JPEG', 
            margin, 
            yPos, 
            pdfContentWidth, 
            pdfContentHeight
          );
          
          // 释放内存
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        // 保存PDF
        PDF.save(title + '.pdf');
        
      } catch (error) {
        console.error('生成PDF失败:', error);
        throw error;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/htmlToPdfByPage.js